export default "__VITE_ASSET__DuyFJq7X__"